import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class Application extends Controller {
  queryParams = ['fetchScenario'];

  @action
  addScrollBlock() {
    const element = document.scrollingElement as HTMLElement;
    if (element) {
      element.dataset.scrollBlock = 'true';
    }
  }

  @action
  removeScrollBlock() {
    const element = document.scrollingElement as HTMLElement;
    if (element) {
      delete element.dataset.scrollBlock;
    }
  }
}
